import React from 'react';

interface Props {
    checked: boolean;
    onChange?: (checked: boolean) => void;
    // shown but not changeable (e.g. "Always on"); faded = the spec's lighter always-on look
    locked?: boolean;
    faded?: boolean;
    label?: string;
}

// v2 on/off switch (44×24), styled in Toggle.scss
const Toggle: React.FC<Props> = ({ checked, onChange, locked, faded, label }) =>
    <button type="button" role="switch" aria-checked={checked} aria-label={label} aria-disabled={locked}
        className={`v2-toggle${checked ? ' on' : ''}${locked ? ' locked' : ''}${faded ? ' faded' : ''}`}
        title={locked ? 'Always on' : undefined}
        onClick={() => { if (!locked && onChange) onChange(!checked); }}>
        <span />
    </button>;

export default Toggle;
